module.exports = __webpack_public_path__ + "img/share_link_setting.d8ee4cf6.svg";